<div class="container searchC">
    <div class="row header">
        <div class="title">Search Students</div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 radioGrp">
                <div class=""><span class="me-3">School Year</span></div>
                <div class="">
                    <input type="radio" value={{currSchoolYear}} name="year" id="current_school_year" [(ngModel)]="schoolYear"  />
                    <label for="current_school_year">This year ({{currSchoolYear}}-{{nextSchoolYear}})</label>
                </div>
                <div class="">
                    <input type="radio" value={{prevSchoolYear}} name="year" id="last_school_year" [(ngModel)]="schoolYear"  />
                    <label for="last_school_year">Last year ({{prevSchoolYear}}-{{currSchoolYear}})</label>
                </div>
            </div>
        </div>
        <div class="row searchtabs">
            <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <button class="nav-link active" id="student-search-tab" data-bs-toggle="tab"
                        data-bs-target="#student-search" type="button" role="tab" aria-controls="nav-home" (click)="toggleTab($event)"
                        aria-selected="true">Search For Student By Keyword</button>
                    <button class="nav-link" id="campus-search-tab" data-bs-toggle="tab" data-bs-target="#campus-search"
                        type="button" (click)="toggleTab($event)"  role="tab" aria-controls="nav-profile" aria-selected="false">Search For Student By
                        Campus</button>
                </div>
            </nav>
        </div>
    </div>
    <div class="row">
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="student-search" role="tabpanel"
                aria-labelledby="student-search-tab">
                <app-search-by-keyword [selectedSchoolYear]="schoolYear" [isSearchKeyword]="issearchKeyword" ></app-search-by-keyword>
            </div>
            <div class="tab-pane fade" id="campus-search" role="tabpanel" aria-labelledby="campus-search-tab">
                <app-search-by-campus [selectedSchoolYear]="schoolYear" [isSearchKeyword]="issearchKeyword"></app-search-by-campus>
            </div>
        </div>
    </div>
</div>
